<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-svg icon-arrow-down"
  >
    <g fill-rule="evenodd">
      <g
        transform="translate(-372.000000, -374.000000)"
        class="fill"
      >
        <g transform="translate(372.000000, 374.000000)">
          <path d="M12,16.2926708 C11.7333372,16.2926708 11.4826704,16.1886708 11.2940036,16.0006707 L4.14666674,8.85400043 C4.05200003,8.75933371 4,8.63400032 4,8.5 C4,8.36666685 4.05200003,8.24066679 4.14666674,8.14666674 C4.24133345,8.05200003 4.36666685,8 4.5,8 C4.63333365,8 4.75933371,8.05200003 4.85333376,8.14666674 L12,15.2926703 L19.1466742,8.14666674 C19.241341,8.05200003 19.3666744,8 19.5,8 C19.6333411,8 19.7593412,8.05200003 19.8533413,8.14666674 C19.948008,8.24133345 20,8.36666685 20,8.5 C20,8.63333365 19.948008,8.75933371 19.8533413,8.85333376 L12.706671,16 C12.5186709,16.1886708 12.2673375,16.2926708 12,16.2926708 L12,16.2926708 Z" />
        </g>
      </g>
    </g>
  </svg>
</template>
